const ChatHistoryLoader = ({ cardCount = 3 }) => {
  return (
    <div className="item_loader_cont">
        <div className="item_loader_cont_header">
            <div className="item_loader_cont_header_item fade-in item_loader_cont_header_item_first"></div>
            <div className="item_loader_cont_header_item fade-in item_loader_cont_header_item_second"></div>
        </div>
      <div className="table_loader_body">
        {Array.from({ length: cardCount }).map((_, index) => (
          <div key={index} className="table_loader_body_rows fade-in" />
        ))}
      </div>
    </div>
  );
};

export default ChatHistoryLoader;